export default __webpack_public_path__ + "static/media/greenhouse-logo.a86e1d91.svg";